import { useState } from "react";
import { NotificationManager } from "react-notifications";
import { api } from "../../../../../../../../../utility/api";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";

export const CargasTancadaApi = () => {
    const [cargando, setCargando] = useState(false);

    const getAlmacenes = async (idTancada, params) => {
        const finalParams = {
            no_paginar: true,
            ...params,
        };

        return api
            .get(`tancadas/${idTancada}/get_almacenes`, finalParams)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch((error) => {
                const errorMsg = getErrorFromResponse(
                    error,
                    "Error al obtener los almacenes",
                );
                NotificationManager.error(errorMsg, "Error", 5000);
                return [];
            });
    };

    const getBultosSkim = async (params) => {
        const finalParams = {
            no_paginar: true,
            filtrar_disponibles: true,
            ...params,
        };

        return api
            .get("bultos_skim", finalParams)
            .then((data) => {
                if (data) return data;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    // pallets y sobrante disponibles en un almacén de reproceso; el almacén es
    // obligatorio, cada uno solo dispone de lo que recibió
    const getDisponiblesReproceso = async (endpoint, params) => {
        const finalParams = {
            no_paginar: true,
            filtrar_disponibles: true,
            ...params,
        };

        try {
            setCargando(true);
            const response = await api.get(endpoint, finalParams);
            return response || [];
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el reproceso disponible",
            );
            NotificationManager.error(errorMsg, "Error", 5000);
            return [];
        } finally {
            setCargando(false);
        }
    };

    const getInventarioReproceso = async (params) =>
        getDisponiblesReproceso("inventario_reproceso", params);

    const getSobranteReproceso = async (params) =>
        getDisponiblesReproceso("sobrante_reproceso", params);

    // pallets con pacas por consumir que no aparecen porque llegaron al almacén
    // después de la fecha y hora del reloj de producción
    const getPalletsLlegadosDespues = async (params) => {
        return api
            .get("inventario_reproceso/pallets_llegados_despues", params)
            .then((data) => {
                if (data) return data.pallets;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const agregarCargaTancada = async (idTancada, data) => {
        try {
            setCargando(true);
            const response = await api.post(
                `tancadas/${idTancada}/agregar_carga`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const eliminarCargaTancada = async (idTancada, idCarga) => {
        try {
            setCargando(true);
            const response = await api.eliminar(
                `tancadas/${idTancada}/eliminar_carga/${idCarga}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getCargasTancada = async (id) => {
        try {
            setCargando(true);

            const response = await api.get(`tancadas/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getAlmacenes,
        getBultosSkim,
        getInventarioReproceso,
        getPalletsLlegadosDespues,
        getSobranteReproceso,
        agregarCargaTancada,
        eliminarCargaTancada,
        getCargasTancada,

        cargando,
    };
};
